// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_069ab3', '__Montserrat_Fallback_069ab3'","fontStyle":"normal"},"className":"__className_069ab3","variable":"__variable_069ab3"};